import React from 'react';
import { Link } from 'react-router-dom';

export default function LegalLinks({ tone = 'dark', className = '' }) {
  const cls = tone === 'dark' ? 'text-neutral-500 hover:text-white' : 'text-neutral-500 hover:text-[#1a1a2e]';
  return (
    <div className={`flex items-center justify-center gap-3 text-xs ${className}`} data-testid="legal-links">
      <Link to="/privacy" className={`${cls} transition-colors underline-offset-2 hover:underline`} data-testid="legal-privacy-link">Privacy Policy</Link>
      <span className="text-neutral-600" aria-hidden="true">·</span>
      <Link to="/terms" className={`${cls} transition-colors underline-offset-2 hover:underline`} data-testid="legal-terms-link">Terms of Use</Link>
      <span className="text-neutral-600" aria-hidden="true">·</span>
      <Link to="/delete-account" className={`${cls} transition-colors underline-offset-2 hover:underline`} data-testid="legal-delete-link">Delete account</Link>
    </div>
  );
}
